import { render } from "./input-number.component.vue?vue&type=template&id=2dae34a0"
import script from "./input-number.component.vue?vue&type=script&lang=js"
export * from "./input-number.component.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__